"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyIntToUrl = exports.propertyToUrl = void 0;
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var format_1 = require("@/utils/format");
var purposeMap = (_a = {},
    _a[SfilterTypeGroup_1.SfilterType.RENT] = 'rent',
    _a[SfilterTypeGroup_1.SfilterType.BUY] = 'buy',
    _a[SfilterTypeGroup_1.SfilterType.ALL] = 'all',
    _a[SfilterTypeGroup_1.SfilterType.BUYRENT] = 'buy-rent',
    _a);
exports.propertyToUrl = function (lang, name, id, type) {
    var nameNormalized = format_1.default.normalize(name);
    var purposeString = purposeMap[type];
    return "/" + lang + "/property/" + nameNormalized + "/" + id + "?purpose=" + purposeString;
};
exports.propertyIntToUrl = function (domain, name, refId, location) {
    var nameNormalized = format_1.default.normalize(name);
    return domain + "/buy_luxury_property/" + refId + "_" + nameNormalized + "_" + location.toLowerCase() + "/" + refId;
};
